import React from 'react';
import { Title } from 'shared';

import { TutorialList } from 'features/tutorials/components/TutorialList';

const TutorialsPage = () => {
  return (
    <>
      <Title title="Tutorials" />
      <TutorialList />
    </>
  );
};

export default TutorialsPage;
